
import { Component, OnDestroy } from '@angular/core';

@Component({
    selector: 'loader',
    template: `<div id="pause" class="d-flex align-items-center justify-content-center">
                <div id="spinner"></div>
                </div>`,
    styleUrls: ['loader.scss']
})

export class LoaderComponent {
    ngOnInit(): void {
    }
}
